import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { IAttributes } from './Attributes'

import TwoSidedLayoutBlockComponent from 'app/components/CustomBlocks/layout/TwoSideLayoutBlock/TwoSidedLayoutBlockComponent'
import { ReactBlocks } from 'app/helpers/Blocks'

const TwoSideLayoutBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <TwoSidedLayoutBlockComponent {...attributes}>
      <ReactBlocks innerBlocks={props.innerBlocks} />
    </TwoSidedLayoutBlockComponent>
  )
}

export default TwoSideLayoutBlock
